<template>
  <v-container>
    <v-row align="center">
      <v-col cols="12" sm="12" md="12">
        <v-card :loading="loading">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field 
                  v-model="search.keyword"
                  hide-details="auto" 
                  label="Từ khóa..." 
                  placeholder="Từ khóa..."
                  autocomplete="off"
                  outlined
                  dense
                  flat
                  solo
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn 
                  color="info"
                  @click="searchTrade"
                  class="py-5"
                  block
                >
                  Tìm kiếm
                </v-btn> 
              </v-col>
              <v-col cols="12" md="2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="info"
                      class="py-5"
                      block
                    >
                      <v-icon>
                        mdi-sort
                      </v-icon>
                      <v-icon>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item-group
                      v-model="selectedOrderItem"
                      color="primary"
                    >
                      <template v-for="(order, index) in orders">
                        <v-list-item
                          :key="`order${index}`" 
                          :value="order.value"
                        >
                          <v-list-item-title>
                            <v-icon>
                              {{order.action}}
                            </v-icon>
                            {{order.text}}
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn 
                  color="success"
                  v-on:click="showDialog()"
                  class="py-5"
                  block
                >
                  Đăng tin
                </v-btn> 
              </v-col>
            </v-row>
            <v-slide-y-reverse-transition>
              <v-row v-if="showf">
                <v-col
                  cols="12"
                  sm="auto"
                >
                  <v-select
                    v-model="search.product_type"
                    :items="product_types"
                    item-text="ten_loai"
                    item-value="id"
                    label="Loại mặt hàng"
                    multiple
                    dense
                    hide-details
                    outlined
                    flat
                    solo
                    clearable
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="auto"
                >
                  <v-checkbox
                    v-model="search.type"
                    label="Cần bán"
                    color="red"
                    value="0"
                    hide-details
                    class="mt-1"
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  sm="auto"
                >
                  <v-checkbox
                    v-model="search.type"
                    label="Cần mua"
                    color="red"
                    value="1"
                    hide-details
                    class="mt-1"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-slide-y-reverse-transition>
            <v-row>
              <v-col
                align="center"
                justify="center"
                class="pa-0"
              >
                <v-icon 
                  color="blue"
                  medium
                  @click="showFilter"
                >mdi-chevron-{{!showf ? 'down' : 'up'}}</v-icon>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <h5 class="text-center py-2 font-weight-light">
      Trang {{currentPage}} (Tổng {{totalPages}} Trang, {{totalItems}} tin cung cầu)
    </h5>
    <v-alert
      text
      class="text-center"
      color="red"
      v-if="!items.length"
    >
      <v-icon left>
        mdi-magnify
      </v-icon>
      Không tìm thấy giao dịch nào! Thử điều chỉnh lại các bộ lọc
    </v-alert>
    <v-row v-else>
      <v-col 
        cols="12" 
        v-for="(item, index) in items"
        :key="index"
      >
        <v-hover v-slot="{ hover }">
          <v-sheet 
            :elevation="hover ? 1 : 0"
            outlined 
            rounded
          >
            <v-card elevation="0">
              <v-card-text>
                <v-list-item>
                  <template v-slot:default="{ active }">
                    <v-list-item-avatar size="55" class="mr-10">
                      <v-img
                        v-if="item.user.info && item.user.info.anh_dai_dien"
                        :src="`${apiBaseUrl}/uploads/${item.user.info.anh_dai_dien}`"
                        lazy-src="@/assets/NoImage.jpg"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="yellow"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                        v-else
                        src="@/assets/NoImage.jpg"
                      >
                      </v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <router-link
                          :to="{ name: 'TradeView', params: { id: item.id }}"
                        >
                          {{item.tieu_de}}
                        </router-link>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-chip-group
                          active-class="deep-purple accent-4 white--text"
                          column
                        >
                          <v-chip small>
                            <v-icon small>mdi-account</v-icon>
                            {{item.user.name}}
                          </v-chip>
                          <v-chip small>
                            <v-icon small>mdi-clock-time-nine-outline</v-icon>
                            {{item.custom_created_at}}
                          </v-chip>
                        </v-chip-group>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>{{item.dia_chi}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content 
                      class="text-center"
                    >
                      <v-icon 
                        small
                        color="black"
                      >
                        mdi-eye
                      </v-icon>
                      <v-list-item-title>{{item.view}}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="text-center">
                      <v-chip 
                        small 
                        :color="item.the_loai_id==0 ? 'success' : 'orange'"
                        class="white--text"
                      >
                        <v-icon left small>mdi-tag</v-icon>
                        {{item.the_loai_id==0 ? 'cần mua' : 'cần bán'}}
                      </v-chip>
                      <div class="primary--text">
                        {{item.published_at}}
                      </div>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-hover>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <Form
      :showDialog="dialog" 
      :item="item" 
      :user="parseInt($store.state.authMod.user.user.id)"
      @confirmed="onConfirmed" 
      @cancelled="onCancelled"
    />
  </v-container>
</template>
<script>
  import Form from '@/views/admin/trades/Form';
  import { mapState } from 'vuex';
  export default {
    components: {
      Form,
    },
    data: () => ({
      search: {
        keyword: '',
        product_type: '',
        type: []
      },
      loading: false,
      currentPage: 1,
      totalItems: 0,
      totalPages: 0,
      selected: [2],
      items: [],
      showf: false,
      product_types: [],
      selectedOrderItem: null,
      orders:[
        {
          action: 'mdi-order-alphabetical-ascending', 
          value: 'tieu_de', 
          text: 'Tiêu đề'
        },
        {
          action: 'mdi-order-numeric-ascending', 
          value: 'created_at', 
          text: 'Ngày đăng'
        }
      ],
      dialog: false,
      item: {},
    }),
    computed: {
      ...mapState([ 
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted () {
      this.initialize();
      this.getProductTypes();
    },
    methods: {
      getProductTypes () {
        axios.get("api/v1/public/product-types")
          .then(response => {
            this.product_types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        if(this.search)
        {
          if(this.search.type){
            params["type"] = this.search.type;
          }
          if(this.search.product_type){
            params["product_type"] = this.search.product_type;
          }
          if(this.search.keyword){
            params["keyword"] = this.search.keyword;
          }
          if(this.selectedOrderItem){
            params["order"] = this.selectedOrderItem;
          }
        }

        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.initialize();
      },
      initialize () {
        const params = this.getRequestParams(
          this.currentPage,
        );
        this.loading = true;
        let request = {
          params: params
        };
        axios.get("api/v1/public/trades", request)
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            this.totalPages = Math.ceil(caluTotalPage);
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      searchTrade(){
        this.initialize();
      },
      showFilter(){
        this.showf = !this.showf;
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled() {
        this.dialog = false;
      },
    }
  }
</script>